import home from "./home";
import market from "./market";
import mail from "./mail";
import proTrading from "./proTrading";
import merchandiser from './v2/merchandiser'
// import otcV2 from './v2/otc'
import loginV2 from './v2/login'
import userCenter from './v2/userCenter'
import property from './v2/property'
import invite from './v2/invite'
import games from './v2/games'
import options from './v2/options'
import h5 from "./v2/h5"
import kyc from './v2/kyc'
import tradingContest from "./v2/newTradingContest"
import taskCenter from "./v2/taskCenter"
import ieo from "./v2/ieo"
import earn from "./v2/earn"
import agent from "./v2/agent"
import search from "./v2/search"
import sports from "./v2/sports"
import live from "./v2/live"
import hongbao from "./v2/hongbao"
import worldCup from "./v2/worldCup"
import { beforeEach, afterEach } from "@/assets/js/router.extends.js";
Vue.use(VueRouter);
const router = new VueRouter({
  routes: [
    ...home,
    ...market,
    // ...otcV2,
    ...loginV2,
    ...userCenter,
    ...property,
    ...invite,
    ...proTrading,
    ...mail,
    ...merchandiser,
    ...h5,
    ...tradingContest,
    ...games,
    ...options,
    ...taskCenter,
    ...ieo,
    ...kyc,
    ...earn,
    ...agent,
    ...sports,
    ...search,
    ...live,
    ...hongbao,
    ...worldCup,
    {
      path: "/*",
      // redirect: { name: "home" },
      component: () => import("@/pages/404"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },
  mode: "history",
});

router.beforeEach(beforeEach);
// router.afterEach(afterEach);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js